import { JsonObject, JsonProperty } from 'json2typescript';

import SettlementCartHistoryItem from '@/models/entry/SettlementCartHistoryItem';

@JsonObject('settlement_cart_history')
export default class SettlementCartHistory {
  constructor() {
    this.settlementDate = '';
    this.amount = 0;
    this.settlementStatus = '';
    this.cartHistoryItems = new Array<SettlementCartHistoryItem>();
  }

  @JsonProperty('settlement_date')
  public settlementDate: string;

  @JsonProperty('amount')
  public amount: number;

  @JsonProperty('settlement_status')
  public settlementStatus: string;

  @JsonProperty('cart_history_items', [SettlementCartHistoryItem], true)
  public cartHistoryItems: SettlementCartHistoryItem[];
}
